import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { supabase } from '@/shared/lib/auth'
import { validateRedirect } from '@/shared/lib/auth'

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackPage,
})

function AuthCallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    supabase.auth.exchangeCodeForSession(window.location.href).then(({ data, error }) => {
      if (error || !data.session) {
        void navigate({ to: '/entrar', search: { error: 'auth_failed', redirect: undefined, code: undefined } })
        return
      }
      const stored = sessionStorage.getItem('auth:redirect')
      sessionStorage.removeItem('auth:redirect')
      const dest = stored ? validateRedirect(stored) : null
      window.location.replace(dest ?? '/home')
    })
  }, [navigate])

  // Intentionally minimal — this screen is transient (< 1s)
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <span>Entrando...</span>
    </div>
  )
}
